<div class="action">
  <app-popup-top-line></app-popup-top-line>
  <div class="action-header">
    <div class="title">Change to {{ data.quarantineStatus }}: {{ data.itemName }}</div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="noClicked()" />
  </div>
  <div class="action-body">
    <div class="description-text">A quarantined app can't be launched by anyone, except the user who built it.</div>
    <div class="confirmation-text">
      To confirm change of the quarantine state, type
      <em>{{ data.quarantineStatus }}</em> in the text input field.
    </div>
    <div
      class="input"
      [ngClass]="{
        'search-invalid':
          textValidationControl.invalid && (textValidationControl.dirty || textValidationControl.touched),
      }"
    >
      <input
        class="search-input"
        type="text"
        [formControl]="textValidationControl"
        placeholder="{{ data.quarantineStatus }}"
      />
    </div>
    <div class="disclaimer">* Changes will be applied immediately and be reflected in Zenity within 24h</div>
  </div>
  <div class="action-footer">
    <div class="cancel" (click)="noClicked()">No</div>
    <div class="confirm" (click)="yesClicked()" [ngClass]="{ 'confirm-disabled': textValidationControl.invalid }">
      Yes
    </div>
  </div>
</div>
